// jscpd:ignore-start
import { isPlatformBrowser } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID} from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { mobileErrorMessage, mobileHyphensComplete, mobileHyphensSetInstead, validateNumber } from 'src/app/core/helpers/app-link'
import { addFocusOutEventSetInvalid, clickoutCloseInput, removeInvalidOn, setInvalidOn, setMobileAfterChangeAllHyphens } from 'src/app/core/helpers/fields-utils'
import { inputAriaCheckActiveState } from 'src/app/core/helpers/inputs-helper'
import { mobileSetValueInputArea, scrollModalToTop } from '../options-utils/modal-shared'
import { SharedDataService } from '../../../../core/services/shared-data.service'

// jscpd:ignore-end
@Component({
    selector: 'app-modal-options-excepton-flow',
    templateUrl: './modal-options-exception-flow.component.html',
    styleUrls: ['./modal-options-exception-flow.component.scss'],
    standalone: false
})
export class ModalOptionsExceptonFlowComponent implements OnInit {
  @Output() sendAppLinkEvent: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Input() breakpoints: any = [{}]
  @Input() loanAcctId: any = null
  @Input() mobileNumber = ''

  constructor(
    public logger: NGXLogger,
    private cdr: ChangeDetectorRef,
    public sharedDataService: SharedDataService,
    @Inject(PLATFORM_ID) private platformId: object) { }

  toSendAppLinkEvent(event) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const targetDivId = 'appLinkInputModalDiv'
    // TODO: we need loanAcctId (if exists from response), mobile from input, cobo: false, email: '' here
    const numbr = (document.getElementById('appLinkInputModal') as any).value
    if (!numbr || !validateNumber(numbr)) {
      // this.notifier.notify('error', mobileErrorMessage)
      setInvalidOn(targetDivId)
      return
    }
    removeInvalidOn(targetDivId)
    // this.sendAppLinkEvent.emit(numbr)
    this.sendAppLinkEvent.emit({ email: '', phone: numbr, loanAcctId: this.loanAcctId || '', cobo: false })
    this.cdr.detectChanges()
  }

  ngOnInit() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.cdr.detectChanges()
    // client code
    if (isPlatformBrowser(this.platformId)) {
      // this.mobileNumber = this.mobileNumber ? this.mobileNumber.slice(0,3) + '-' + this.mobileNumber.slice(3,6) + '-' + this.mobileNumber.slice(6) : ''
      scrollModalToTop()
      // setTimeout(() => {
      //   // setMobileAfterChangeAllHyphens('appLinkInputModal')
      // }, 1000)
      setTimeout(() => {
        mobileSetValueInputArea('appLinkInputModalDiv', 'appLinkInputModal', this.mobileNumber)
        addFocusOutEventSetInvalid('appLinkInputModal', 'appLinkInputModalDiv', validateNumber)

        // if (this.mobileNumber) {
        //   (document.getElementById('appLinkInputModal') as any).disabled = true
        // }
      }, 200)
    }
    setTimeout(() => {
      this.toggleLoader.emit(false)
      this.cdr.detectChanges()
    }, 300)
  }


  inputItemClick(event: any): void
  {
    inputAriaCheckActiveState(event.currentTarget)
  }



  onMobileInput(e) {
    mobileHyphensComplete(e, e.target)
  }


  @HostListener('document:click', ['$event'])
  clickout(event) {
    clickoutCloseInput(event)
  }

}
